export const ENDPOINTS_CACHE_KEY = 'endpoints'
export const PKCE_CACHE_KEY = 'pkce-verifier'
export const STATE_CACHE_KEY = 'auth-state'

/**
 * Event name dispatched when session validation detects the user is no longer authenticated.
 * Applications can listen to this event to show the session expired modal.
 */
export const SESSION_EXPIRED_EVENT = 'session-expired'
